/* DefaultSnapshotRenderer.js */

"use strict";

//const _ = require("lodash");

class DefaultSnapshotRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("defaultSnapshot-column");
        this._rootElem.component = this._model;
        this._snapshotIcon = document.createElement("base-icon-gl");
        this._snapshotIcon.dataset.icon = "common.star";
        this._rootElem.appendChild(this._snapshotIcon);

        this._registerListeners();
        this.render();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _shutdown() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            resolve();
        });
        return prom;
    }
    _registerListeners() {
        this._model.on("DefaultSnapshot", (this._onDefaultSnapshot = this._onDefaultSnapshot.bind(this)));
    }
    _unregisterListeners() {
        this._model.removeAllListeners("DefaultSnapshot");
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._setDefaultSnapshot(this._model.getValue());
            resolve();
        });
        return prom;
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    _onDefaultSnapshot(newVal) {
        this._setDefaultSnapshot(newVal);
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/

    _setDefaultSnapshot(newVal) {
        this._rootElem.innerHTML = "";
        if (newVal) {
            this._snapshotIcon = document.createElement("base-icon-gl");
            this._snapshotIcon.dataset.icon = "common.star";
            this._rootElem.appendChild(this._snapshotIcon);
        }
    }

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = DefaultSnapshotRenderer;
